import { NgModule } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule } from 'primeng/blockui';
import { EditorModule } from 'primeng/editor';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { FieldsetModule } from 'primeng/fieldset';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { InputMaskModule } from 'primeng/inputmask';
import { FluidModule } from 'primeng/fluid';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressBarModule } from 'primeng/progressbar';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { AccordionModule } from 'primeng/accordion';
import { TextareaModule } from 'primeng/textarea';
import { BadgeModule } from 'primeng/badge';
import { TabsModule } from 'primeng/tabs';
import { SplitButtonModule } from 'primeng/splitbutton';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ChartModule } from 'primeng/chart';
import { ToastModule } from 'primeng/toast';
import { PopoverModule } from 'primeng/popover';
import { DialogModule } from 'primeng/dialog';
import { TimelineModule } from 'primeng/timeline';
import { MeterGroupModule } from 'primeng/metergroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FileUploadModule } from 'primeng/fileupload';
import { SliderModule } from 'primeng/slider';
import { InputGroup, InputGroupModule } from 'primeng/inputgroup';
import { CarouselModule } from 'primeng/carousel';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { FocusTrapModule } from 'primeng/focustrap';

const m = [
  ButtonModule,
  BreadcrumbModule,
  MessageModule,
  PanelMenuModule,
  AvatarModule,
  MenuModule,
  SkeletonModule,
  TableModule,
  PaginatorModule,
  IconFieldModule,
  InputIconModule,
  InputTextModule,
  BlockUIModule,
  EditorModule,
  PanelModule,
  RadioButtonModule,
  CheckboxModule,
  FieldsetModule,
  ToggleSwitchModule,
  PasswordModule,
  TooltipModule,
  InputMaskModule,
  FluidModule,
  AutoCompleteModule,
  SelectModule,
  DrawerModule,
  DynamicDialogModule,
  IftaLabelModule,
  SelectButtonModule,
  ConfirmDialogModule,
  InputNumberModule,
  ProgressBarModule,
  ColorPickerModule,
  MultiSelectModule,
  DatePickerModule,
  AccordionModule,
  TextareaModule,
  BadgeModule,
  TabsModule,
  SplitButtonModule,
  AvatarGroupModule,
  ChartModule,
  ToastModule,
  PopoverModule,
  DialogModule,
  TimelineModule,
  MeterGroupModule,
  InputGroupAddonModule,
  InputGroupModule,
  FileUploadModule,
  SliderModule,
  InputGroup,
  CarouselModule,
  CardModule,
  ProgressSpinnerModule,
  OverlayBadgeModule,
  FocusTrapModule,
];

@NgModule({
  declarations: [],
  providers: [ConfirmationService, MessageService, DialogService],
  imports: m,
  exports: m,
})
export class PrimengModule {}
